import { isString } from 'lodash-es';

export function hasText<T extends string>(value: unknown): value is T {
  return isString(value) && value.trim().length > 0;
}

export function isEmailValid(email: unknown): boolean {
  if (!hasText(email)) {
    return false;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
}
